import axiosClient from './axiosClient';
const MenuPublicApi = {
    getAll: () => {
        const url = '/menupublic/getall';
        return axiosClient.get(url)
    },
}
export default MenuPublicApi;